<template>
  <span
    @click="clickAction"
    class="text-blue-600 font-bold hover:text-blue-600 cursor-pointer"
  >
    {{ value }}
  </span>
</template>

<script setup>
import { computed } from 'vue'

/**
 * @typedef {Object} StatusCellParams
 * @param {String} value
 */
const props = defineProps({
  /** @type {StatusCellParams} */
  params: {
    type: Object,
    required: true
  }
})

const value = computed(() => {
  if (props.params.valueFormatter) {
    return props.params.valueFormatter(props.params)
  }

  return props.params.value
})

const clickAction = () => {
  props.params.clickAction(props.params.data)
}
</script>
